import React, { useMemo, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';
import { EmptyState } from '@/components/custom/empty-state';

HC_more(Highcharts);

export function GreDistributionChart({ data = [] }) {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = useMemo(
    () => ({
      chart: {
        type: 'pie',
        backgroundColor: 'transparent'
      },
      credits: { enabled: false },
      title: { text: null },
      tooltip: {
        pointFormat: 'Desafios ativados: <b>{point.y}</b>'
      },
      series: [
        {
          name: 'GRE',
          colorByPoint: true,
          data: data.map(item => ({ name: item.name, y: item.value })),
          innerSize: '0%'
        }
      ],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: { enabled: false },
          showInLegend: true
        }
      },
      legend: {
        enabled: true,
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        itemMarginBottom: 8,
        itemStyle: { fontSize: '11px', fontWeight: 'normal' },
        width: screenWidth > 768 ? 620 : undefined
      },
      responsive: {
        rules: [
          {
            condition: { maxWidth: 768 },
            chartOptions: {
              legend: {
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                width: '100%'
              }
            }
          }
        ]
      }
    }),
    [data, screenWidth]
  );

  if (!data.length) {
    return (
      <EmptyState
        type="data"
        variant="plain"
        text="Nenhum dado disponível"
      />
    );
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  );
}
